import { ANALYTIC_EVENT } from '@sravni/cosago-react-library/lib/constants';
import { useSubscribeOnEvent } from '@sravni/cosago-react-library/lib/hooks';
import type { IAnalyticsEventFormField } from '@sravni/cosago-react-library/lib/types';

import { sendAnalyticEvent } from './sendAnalyticEvent';

/*
 * перехватываем все кастомные события формы и отправляем их в аналитику
 */
export const useSubscribeOnCustomFormAnalyticsEvent = (
  sendEvent: (e: IAnalyticsEventFormField) => void,
  eventTarget?: Nullable<EventTarget>,
) => {
  useSubscribeOnEvent(ANALYTIC_EVENT, sendAnalyticEvent(sendEvent), eventTarget);
};
